<div class="profile-page">
  <!-- Breadcrumb -->
  <div class="profile-page__breadcrumb">
    <div class="profile-page__inner">
      <app-breadcrumb [items]="breadcrumbs" />
    </div>
  </div>

  @if (isAuthenticated()) {
    @if (currentUser(); as user) {
      <app-profile-header [user]="user" />
    }

    <!-- Tabs -->
    <app-profile-tabs />

    <!-- Tab content -->
    <div class="profile-page__content">
      <div class="profile-page__inner">
        <router-outlet />
      </div>
    </div>
  } @else {
    <div class="profile-page__content">
      <div class="profile-page__inner">
        <div class="profile-page__signed-out">
          <h1 class="profile-page__title">{{ copy.PAGE_TITLE }}</h1>
          <p class="profile-page__signed-out-text">{{ copy.SIGNED_OUT.MESSAGE }}</p>
          <app-button variant="primary" size="md" (click)="openLogin()">
            {{ copy.SIGNED_OUT.LOGIN_BUTTON }}
          </app-button>
        </div>
      </div>
    </div>
  }
</div>
